
import Profile from '../views/Auth/Profile'

const routes = {
  path: '/users',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        pageTitle: 'Profile',
        breadcrumb: [
          {
            text: 'My profile',
            active: true,
          },
        ],
      },
    },
  ]
};


export default routes
